<template>
  <div class="ful-page">
    <div class="ful-page-wrapper">
      <div class="ful-page-topnav">
        <button class="ful-btn-back" @click="goBack">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
          返回
        </button>
        <h1 class="ful-page-title">配送订单详情</h1>
      </div>
      <section class="ful-page-card">
        <OrderHeader :orderInfo="orderInfo" :countDownHour="countDownHour" :countDownMinute="countDownMinute" :countDownSecond="countDownSecond" :bare="true" @toPayPage="toPayPage" @applyRefund="applyRefund">
          <template #status-icon>
            <svg v-if="isPaid" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            <svg v-else width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          </template>
        </OrderHeader>
        <div class="ful-page-body">
          <div class="ful-page-left">
            <div class="ful-inner-section">
              <div class="ful-inner-section-heading">
                <span class="ful-inner-section-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg></span>
                <div><p class="ful-inner-section-eyebrow">Delivery order</p><h2 class="ful-inner-section-title">配送订单信息</h2></div>
              </div>
              <div class="ful-delivery-footer">
                <RecipientInfo :orderInfo="orderInfo" :bare="true" :showHeading="false" />
                <button v-if="showModifyAddress" class="ful-btn-edit" @click="modifyAddress">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>修改
                </button>
              </div>
              <div style="margin-top:20px;padding-top:20px;border-top:1px solid rgba(25,70,43,0.10)">
                <OrderDetailInfo :orderInfo="orderInfo" :bare="true" :showHeading="false" />
              </div>
            </div>
            <div v-if="hasPatientInfo" class="ful-inner-section"><PatientInfo :consultInfo="consultInfo" :bare="true" /></div>
            <div v-if="hasSymptoms" class="ful-inner-section"><SymptomTable :basicTableArray="basicTableArray" :shangjiaoTableArray="shangjiaoTableArray" :zhongjiaoTableArray="zhongjiaoTableArray" :xiajiaoTableArray="xiajiaoTableArray" :hasShangJiao="hasShangJiao" :hasZhongJiao="hasZhongJiao" :hasXiaJiao="hasXiaJiao" :bare="true" /></div>
          </div>
          <aside class="ful-sidebar-card">
            <div class="ful-sidebar-heading"><span class="ful-inner-section-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></span><div><p class="ful-inner-section-eyebrow">Order summary</p><h2 class="ful-inner-section-title">本次配送</h2></div></div>
            <div style="display:flex;flex-direction:column;gap:14px;font-size:14px">
              <div class="ful-sidebar-row"><span class="label">处方名称</span><span class="value">{{ orderInfo.typeText || '-' }}</span></div>
              <div class="ful-sidebar-row"><span class="label">配送费用</span><span class="value price">¥ {{ orderInfo.sumPrice || '0.00' }}</span></div>
              <div class="ful-sidebar-divider"><div class="ful-sidebar-row"><span class="label">订单状态</span><span :class="['value','status',isPaid?'paid':'unpaid']">{{ isPaid ? '已支付' : '等待支付确认' }}</span></div></div>
            </div>
          </aside>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  let un_pay_status  = "0" //未支付
  let payed_status  = "1" //已支付
  let order_avaliable_status  = "2" //订单生效
  let prescripting_status  = "3" //配药中
  let expressing_status  = "4" //配送中
  let paying_status  = "99" //配送中
  let express_complete_status  = "5" //配送完成
  import AreaHeader from '@/components/widgets/area-header.vue'
  import OrderHeader from '@/components/fulfillment/common/OrderHeader.vue'
  import ExpressInfo from '@/components/fulfillment/common/ExpressInfo.vue'
  import RecipientInfo from '@/components/fulfillment/common/RecipientInfo.vue'
  import OrderDetailInfo from '@/components/fulfillment/common/OrderDetailInfo.vue'
  import PatientInfo from '@/components/fulfillment/common/PatientInfo.vue'
  import SymptomTable from '@/components/fulfillment/common/SymptomTable.vue'
  import { EventBus } from "../../js/eventbus.js"
  export default {
    name:'fulOrder',
    components:{
      AreaHeader,
      OrderHeader,
      ExpressInfo,
      RecipientInfo,
      OrderDetailInfo,
      PatientInfo,
      SymptomTable,
    },
    data () {
      return {
        orderInfo:{},
        activeNames:'0',
        activeNames1:'1',
        countDownHour:'00',
        countDownMinute:'00',
        countDownSecond:'00',
        tablePrescription:{},
        expressInfo:{},
        basicTableArray:[],
        shangjiaoTableArray:[],
        zhongjiaoTableArray:[],
        xiajiaoTableArray:[],
        consultInfo:{},
        hasShangJiao:false,
        hasZhongJiao:false,
        hasXiaJiao:false,
      }
    },
    computed: {
      isPaid() {
        return this.orderInfo.status != 0 && this.orderInfo.status != 99
      },
      showModifyAddress() {
        return (
          this.orderInfo.status == 0 ||
          this.orderInfo.status == 99 ||
          (this.orderInfo.status > 0 && this.orderInfo.refundFlag == 'Y')
        );
      },
      hasPatientInfo() {
        var c = this.consultInfo || {};
        return !!(c.name || c.sex || c.phoneNo || c.birthday || c.birthHour || c.birthMinute || c.liveArea || c.birthArea);
      },
      hasSymptoms() {
        return (this.basicTableArray && this.basicTableArray.length > 0) ||
          (this.shangjiaoTableArray && this.shangjiaoTableArray.length > 0) ||
          (this.zhongjiaoTableArray && this.zhongjiaoTableArray.length > 0) ||
          (this.xiajiaoTableArray && this.xiajiaoTableArray.length > 0);
      }
    },
      mounted() {
        console.log("fulfillmentOrder mounted")
        this.orderId = this.$route.query.orderId
        this.getOrderInfo()
        var address = sessionStorage.getItem('selectAddress')
        // 获取我的地址
        if(address != null && address.length > 0){
          console.log("address:"+address)
          var addressObj = JSON.parse(address)
          sessionStorage.removeItem('selectAddress')
          this.wjtHttp.post(this,'/api/delivery/order/modify/address',{
              deliveryOrderId: this.orderId,
              recipientAddress: addressObj.province+addressObj.city+addressObj.county+addressObj.street,
              recipientName: addressObj.receiverName,
              recipientPhone: addressObj.phoneNo
          },false,(res)=>{
                var data = res.data
                if(data.code == 200){
                  this.$message('地址修改成功')
                  this.getOrderInfo()
                }else{
                  this.$message({
                      message:(data.msg&&data.msg.length > 0)?data.msg:'修改地址异常',
                      type:'error'
                  })
                }
            },(err)=>{
                console.log(err)
            })
        }
      },
      methods:{
        shouldShowTime(hour, minute) {
          return !(this.isEmptyValue(hour) && this.isEmptyValue(minute));
        },
        isEmptyValue(value) {
          return value === '' || value === null || value === undefined;
        },
        formatTimeValue(value) {
          if (value === '-1' || value === -1 || value === '--') {
            return '--';
          }
          return value;
        },
        goBack(){
            this.$router.go(-1)
        },
        getOrderInfo(){
          this.wjtHttp.get(this,'/api/delivery/order/customTeaInfo/'+this.orderId,{},true,(res)=>{
                var data = res.data
                if(data.code == 200){
                    this.orderInfo = data.data
                    if(this.orderInfo.status == un_pay_status){
                      this.startCountDown(data.data.payCountdown)
                    }
                    if(data.data.status== paying_status){
                      console.log(11111)
                    }else if(data.data.status >= expressing_status){
                      this.getExpressInfo(this.orderId)
                    }
                    
                    this.consultInfo = data.data.patient
                    this.generateTableData()
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'获取订单详情异常',
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
            })
        },
        getExpressInfo(orderId){
          this.wjtHttp.get(this,'/api/delivery/progress/'+orderId,{},false,(res)=>{
                var data = res.data
                if(data.code == 200){
                    this.expressInfo = data.data
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'获取订单详情异常',
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
            })
        },
        startCountDown(timeMill){
          var currentTimeMill = Date.parse(new Date())
          console.log('netMill:'+timeMill)
          console.log('currentMill:'+currentTimeMill)
          if(currentTimeMill > timeMill){
              return
          }
          var totalSecond = (timeMill - currentTimeMill) / 1000;

          clearInterval(this.interval)
          var that = this
          this.interval = setInterval(function () {
            console.log('countdown:'+totalSecond)
            // 秒数
            var second = totalSecond;

            // 小时位
            var hr = Math.floor(second / 3600);
            var hrStr = hr.toString();
            if (hrStr.length == 1) hrStr = '0' + hrStr;

            // 分钟位
            var min = Math.floor((second - hr * 3600) / 60);
            var minStr = min.toString();
            if (minStr.length == 1) minStr = '0' + minStr;

            // 秒位
            var sec = second - hr * 3600 - min * 60;
            var secStr = sec.toString();
            if (secStr.length == 1) secStr = '0' + secStr;
            console.log("hour:"+hrStr)
            console.log("minite:"+minStr)
            console.log("second:"+secStr)
            that.countDownHour=hrStr
            that.countDownMinute=minStr
            that.countDownSecond=secStr
            totalSecond--;
            if (totalSecond < 0) {
              clearInterval(that.interval);
              console.log("倒计时结束")
              that.countDownHour='00'
              that.countDownMinute='00'
              that.countDownSecond='00'
              that.getOrderInfo()
            }
          }, 1000);
        },
        generateTableData(){
          var item = this.orderInfo.prescriptionInfo || this.orderInfo
          var itemArray = item.prescription || this.orderInfo.prescription || []
          var options = []
          for (var k = 0; k < itemArray.length;k++){
              if(k%2 == 0){
                  var pair = Object.assign({}, itemArray[k])
                  if(itemArray[k+1] && itemArray[k+1].key && itemArray[k+1].value !== undefined && itemArray[k+1].value !== null && itemArray[k+1].value !== ""){
                      pair.key1 = itemArray[k+1].key
                      pair.value1 = itemArray[k+1].value
                      pair.index1 = itemArray[k+1].index
                  }
                  options.push(pair)
              }
          }
          // Vue 2 无法检测对象新属性添加，必须用整体替换确保响应式
          this.tablePrescription = {
              count: item.count,
              charge: item.charge,
              totalWeight: item.totalWeight,
              startDate: item.startDate,
              endDate: item.endDate,
              title: item.name,
              prescription: itemArray,
              options: options
          }

          var inquiryInfo = this.orderInfo.inquiryInfo || {}
          this.basicTableArray = this.basicTableArray.concat(inquiryInfo.basic_array || [])
          this.basicTableArray = this.basicTableArray.concat(inquiryInfo.basic_enter_array || [])
          this.basicTableArray = this.basicTableArray.concat(inquiryInfo.maixiang_array || [])
          this.shangjiaoTableArray = inquiryInfo.shangjiao_array || []
          this.zhongjiaoTableArray = inquiryInfo.zhongjiao_array || []
          this.xiajiaoTableArray = inquiryInfo.xiajiao_array || []
          var that = this
          this.shangjiaoTableArray.forEach(function (element) {
              if(element.value.length > 0){
                that.hasShangJiao = true
              }
          })
          this.zhongjiaoTableArray.forEach(function (element) {
              if(element.value.length > 0){
                that.hasZhongJiao = true
              }
          })
          this.xiajiaoTableArray.forEach(function (element) {
              if(element.value.length > 0){
                that.hasXiaJiao = true
              }
          })
        },
        toPayPage(){
          sessionStorage.setItem('fulfillmentPlaceOrderInfo',JSON.stringify(this.orderInfo))
          this.$router.push('/wjtpay')
        },
        modifyAddress(){
          this.$router.push({
            path:'/address',
            query:{
              mode:1
            }
          })
        },
        applyRefund(){
          this.wjtHttp.post(this,'/api/adapay/v1/refund ',{deliveryOrderId: this.orderInfo.deliveryOrderId},false,(res)=>{
                var data = res.data
                if(data.code == 200){
                    this.$message('操作成功')
                    this.getOrderInfo()
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'获取订单详情异常',
                        type:'error'
                    })
                }
            },(err)=>{
                console.log(err)
            })
        }
      },
      destroyed() {
        clearInterval(this.interval)
        EventBus.$off("address",null)
      }
    }
</script>

<style scoped>
/* 布局依赖 fulfillment-common.css 中的 ful-* 类 */
</style>
